'use client';

import { HOST } from '@/lib/config';

export interface FrontendAlert {
  name: string;
  session_id: string | null;
  duration_ms: number;
  url: string;
  user_agent: string;
  viewport: string;
  redux_snapshot: Record<string, unknown>;
}

// Deduplication: only report each (name, session_id) once per page load
const reportedAlerts = new Set<string>();

// Per-name cooldown: prevent spam even across sessions
const cooldowns = new Map<string, number>();
const COOLDOWN_MS = 5 * 60 * 1000; // 5 minutes

/**
 * Fire-and-forget alert to backend when a frontend state appears stuck.
 * Deduplicates by (name, session_id) per page load and rate-limits per name.
 */
export function reportFrontendAlert(alert: FrontendAlert): void {
  const dedupeKey = `${alert.name}:${alert.session_id ?? 'none'}`;

  if (reportedAlerts.has(dedupeKey)) return;

  const lastSent = cooldowns.get(alert.name);
  if (lastSent && Date.now() - lastSent < COOLDOWN_MS) return;

  reportedAlerts.add(dedupeKey);
  cooldowns.set(alert.name, Date.now());

  console.warn(
    `[FrontendWatchdog] Stuck state detected: ${alert.name} (${alert.duration_ms}ms)`,
    alert.session_id
  );

  try {
    fetch(`${HOST}/health/frontend-alert`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(alert),
      keepalive: true,
    }).catch(() => {
      // Best-effort — silently ignore network failures
    });
  } catch {
    // Silently ignore
  }
}
